import type { FandomCmp } from "common-types";

export function getConsent(): boolean {
  return (
    window.fandomCmp?.ready === true &&
    window.fandomCmp?.allowed.ads === true &&
    window.fandomCmp?.optOut === false
  );
}

export function getValueDependingOnConsent<T extends string | number>(
  valueIfOptIn: () => T,
  valueIfOptOut: T,
): T | undefined {
  return getConsent() ? valueIfOptIn() : valueIfOptOut;
}

export function isConsentReadable(consentApi: FandomCmp["consentApi"]) {
  return (
    window.fandomCmp?.ready === true &&
    window.fandomCmp?.allowed.ads === true &&
    window.fandomCmp?.consentApi === consentApi
  );
}
